import { useTranslation } from "react-i18next";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { useFilterState } from "../../customHook/useFilterState";

import './BaseSelectDropDown.sass'

export const BaseSelectDropDown = ({ value, onBlur, header, options, isEditing = false, handleFilterSet, multiple = false, showCheckboxes = false }) => {
  const { filterValue, setFilter, handleBlur } = useFilterState(value, onBlur);
  const { t } = useTranslation();

  const handleChange = (e) => {
    let newValue = e.target.value;

    if (multiple) {
      const finalValue = Array.isArray(newValue) ? newValue : [];
      setFilter(finalValue);
      if (isEditing) {
        onBlur(finalValue);
      }
      if (handleFilterSet) {
        handleFilterSet(finalValue);
      }
    } else {
      const singleValue = newValue || "";
      setFilter(singleValue);
      if (isEditing) {
        onBlur(singleValue);
      }
      if (handleFilterSet) {
        handleFilterSet(singleValue);
      }
    }
  };

  const currentValue = multiple ? Array.isArray(filterValue) ? filterValue : filterValue ? [filterValue] : [] : filterValue || "";

  const getOptionLabel = (option) => {
    return typeof option === 'object' ? option.label : option;
  };

  const getOptionValue = (option) => {
    return typeof option === 'object' ? option.value : option;
  };

  return (
    <FormControl size="small" fullWidth sx={isEditing ? {} : { mt: 1 }}>
      {!isEditing && <InputLabel id="filter-label">{t(header)}</InputLabel>}
      <Select
        labelId="filter-label"
        value={currentValue}
        onChange={handleChange}
        onBlur={!isEditing ? handleBlur : undefined}
        label={isEditing ? "" : t(header)}
        autoFocus={isEditing}
        fullWidth
        multiple={multiple}
        renderValue={multiple ? (selected) => {
          const labels = selected.map(val => {
            const option = options.find(opt => getOptionValue(opt) === val);
            return option ? getOptionLabel(option) : val;
          });
          return <Box className="text-ellipsis">{labels.join(", ")}</Box>;
        } : (selected) => {
          const option = options.find(opt => getOptionValue(opt) === selected);
          return option ? getOptionLabel(option) : selected;
        }}
        MenuProps={{ PaperProps: { className: "element" } }}
      >
        {options.map((option, i) => {
          const optionValue = getOptionValue(option);
          const optionLabel = getOptionLabel(option);
          return (
            <MenuItem key={i} value={optionValue}>
              {multiple && showCheckboxes && <Checkbox checked={Array.isArray(currentValue) && currentValue.includes(optionValue)} size="small" />}
              <ListItemText primary={optionLabel} />
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};